import React, { Component } from 'react';
import { Breadcrumb, BreadcrumbItem, Button, Input, InputGroup, FormFeedback, InputGroupAddon, Col, Container, FormGroup, Label, Row, Card, CardBody } from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Checkbox from '@material-ui/core/Checkbox';
import BusSteppers from "./busSteppers";
import LoginModal from '../../components/user/LoginModal';
import SaveLoader from "../../components/loader/SaveLoader";
import BusItemDetail from "./BusItemDetail";
import { ALL_BUS_STATIONS } from "./BusConfig"
import BusSeats from "./BusSeats";
import PassengerForm from "../../components/search/PassengerForm";
import validator from "validator";
import { LangValidation } from "../../lang/en/validation";
// import momentJalaali from 'moment-jalaali'
import * as moment from 'moment';
import 'moment-timezone';
// import SectionLoader from "../../components/loader/SectionLoader";
import { setUserBus } from "../../redux/actions/user";
import { goBackPassengers } from "../../redux/actions/ticket";
import { ALIBABA_URL } from "../../config/Config";
// import qs from "qs";
import axios from "axios";








class BusPassengers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            data: null,
            airports: [],
            fields: {
                email: "",
                tel: "",
                mobile: "",
                isWhatsapp: false,
                telCode: "+98",
                mobileCode: "+98",
            },
            errors: {},
            country: [],
            pError: [],
            plzlogin: false,
            formvalid: false,
            agree_terms: false,
            passengers: {
                "PassengerType": 1,//Adult = 1, Child = 2, Infant = 3
                "name": "",
                "family": "",
                "Gender": 1,//Male = 1,Female = 2
                "BirthDate": "",
                "DocType": 4,//Passport = 1,NationalId = 4,
                "nationalId": "",
                "passportId": "",
                "passportExpire": "",
                "DocIssuedCountry": "IR",//country iso code
                "id": null
            },
            showEmail: false,
            acceptTerms: false,
            showTerms: false,
            seats: [],
            bustype: [],
            getrequest: false,
        }
    }

    async componentDidMount() {

        const token = localStorage.altrabo_api_token
        const data = {
            "Rph": this.props.item.rph
        }
        const options = {
            method: 'POST',
            headers: {
                // 'content-type': 'application/x-www-form-urlencoded',
                'X-ZUMO-AUTH': token,
                'Content-Type': 'application/json',
            },
            data: JSON.stringify(data),
            url: ALIBABA_URL + 'Bus/GetProposal',
        };
        let response = await axios(options);
        // console.log(response.data.data);

        if (response.status < 200 || response.status > 300) {
            const error = new Error(response.statusText);
            error.response = response;
            console.log(error);

        } else {
            await this.setState({
                bustype: response.data.data,
                getrequest: true
            })
        }
        const userlogin = JSON.parse(JSON.parse(localStorage["persist:root"]).user)
        if (localStorage.length !== 0 && userlogin.apiToken !== null) {
            this.setState({ plzlogin: true })
        } else {
            this.setState({ plzlogin: false })
        }
    }

    async HandelSeats(e) {
        // console.log(e);
        await this.setState({ seats: e })
    }

    render() {
        const { item } = this.props;
        const userislogin = this.props.user.apiToken
        const { fields, errors } = this.state;
        // console.log(item)
        const data = {
            "PassengerType": 1,//Adult = 1, Child = 2, Infant = 3
            "name": "",
            "family": "",
            "Gender": 1,//Male = 1,Female = 2
            "BirthDate": "",
            "DocType": 4,//Passport = 1,NationalId = 4,
            "nationalId": "",
            "passportId": "",
            "passportExpire": "",
            "DocIssuedCountry": "IR",//country iso code
            "id": null
        }
        // let goback;
        // if (ticket['goback'] !== undefined) {

        //     goback = ticket.goback.goback;
        // } else {
        //     goback = false;

        // }
        // console.log(item.rph)
        const orgin = ALL_BUS_STATIONS.filter(i => i.value === item.orginStationCode)[0].label
        const destination = ALL_BUS_STATIONS.filter(i => i.value === item.destinationStationCode)[0].label;

        return (
            <div className="pt-5 mt-5">
                {this.state.loading === true && <SaveLoader type="spinningBubbles" color="#43b185" />}
                <Container className="min-height-500">
                    <Breadcrumb className='w-100 white mt-3'>
                        <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
                        <BreadcrumbItem active>Passenger Information</BreadcrumbItem>
                    </Breadcrumb>
                    <Row>
                        <Col >
                            <div className="white box search-progress">
                                <BusSteppers active={1} />
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-12 mt-3">
                            <h4 className="text-uppercase green-text text-center">Ticket Information</h4>
                        </Col>
                    </Row>
                    <Row className='mt-2 md-5'>
                        <Col md='12' sm='12' >
                            <BusItemDetail item={item} orgin={orgin}
                                destination={destination}
                                seats={this.state.seats}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-12 mt-3">
                            <h4 className="text-uppercase green-text text-center">Choose Your Seat(s) </h4>
                        </Col>
                    </Row>
                    <Row className='mt-2 md-5'>
                        <Col md='12' sm='12' >

                            {this.state.getrequest === false ?
                                <p className='bus-seat-loading' >Wait for Seats information ...</p>
                                :
                                <BusSeats
                                    bustype={this.state.bustype}
                                    getseats={this.HandelSeats.bind(this)}
                                />
                            }

                        </Col>
                    </Row>
                    <Row>
                        <Col className="col-12 mt-3 mb-2">
                            <h4 className="text-uppercase green-text text-center">Passengers Information</h4>
                        </Col>
                    </Row>
                    <Row>
                        {/* {console.log(goback)} */}
                        {/* {goback === true ? */}

                        {/* <Col> */}
                        {/* {console.log(ticket.review_ticket.rev_passengers)} */}
                        {/* {ticket.review_ticket.rev_passengers.map((item, index) =>
                                    <PassengerForm key={index} index={index}
                                        data={item} errors={this.state.pError[index]}
                                        set={this.handleSetPassenger.bind(this)}
                                        islogin={this.state.plzlogin}
                                        review={true}
                                    />
                                )} */}
                        {/* </Col> */}
                        {/* : */}
                        <Col >

                            <PassengerForm
                                data={data} errors={this.state.pError}
                                setbus={this.handleSetPassengerBus.bind(this)}
                                busform={true}
                                islogin={this.state.plzlogin}
                                review={false}
                            />

                        </Col>
                        {/* } */}

                        {/* <Col >
                            {this.state.passengers.map((item, index) =>
                                <PassengerForm key={index} index={index}
                                    data={item} errors={this.state.pError[index]}
                                    set={this.handleSetPassenger.bind(this)}
                                    islogin={this.state.plzlogin}
                                />
                            )}
                        </Col> */}
                    </Row>
                    <Row>
                        <Col className="col-12 mt-3 mb-2">
                            <h4 className="text-uppercase green-text text-center">Contact Information</h4>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Card className="white mb-3 w-100 flight-item padding-for-cart">
                                <CardBody>
                                    <Row>
                                        <Col >
                                            {userislogin === null &&
                                                <FormGroup check className="ml-0 pl-0">
                                                    <Label check>
                                                        <Checkbox
                                                            color="primary"
                                                            onChange={() => this.setState({ showEmail: !this.state.showEmail })}
                                                            checked={this.state.showEmail}
                                                            className='whithout-check-box'
                                                        />
                                                        <div className="login-Modal-p" ><span className='sign-in-span'> Continue without Sign up Or </span><LoginModal /></div>
                                                    </Label>
                                                </FormGroup>
                                            }

                                        </Col>
                                    </Row>
                                    {this.state.showEmail ?
                                        <Row>
                                            <Col md={3} sm={6}>
                                                <FormGroup>
                                                    <Label for="name">Email</Label>
                                                    <Input
                                                        invalid={("email" in errors)}
                                                        name="email"
                                                        type="text"
                                                        placeholder="Email"
                                                        value={fields.email}
                                                        onChange={this.handleChange.bind(this)}
                                                    />
                                                    <FormFeedback style={{ color: "red" }}>{errors.email}</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                            <Col md={3} sm={6}>
                                                <FormGroup>
                                                    <Label for="name">Telephone</Label>
                                                    <InputGroup>
                                                        <InputGroupAddon addonType="prepend">
                                                            <Input

                                                                type="select"
                                                                name="telCode"
                                                                placeholder="Tel"
                                                                value={fields.telCode}
                                                                onChange={this.handleChange.bind(this)}>
                                                                {this.state.country.map((item, index) =>
                                                                    <option key={index} value={item.value}>{item.label}</option>
                                                                )}
                                                            </Input>
                                                        </InputGroupAddon>
                                                        <Input
                                                            invalid={("tel" in errors)}
                                                            name="tel"
                                                            type="text"
                                                            placeholder="Tel"
                                                            value={fields.tel}
                                                            onChange={this.handleChange.bind(this)}
                                                        />
                                                    </InputGroup>
                                                    <FormFeedback style={{ color: "red" }}>{errors.email}</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                            <Col md={3} sm={6}>
                                                <FormGroup>
                                                    <Label for="name">Mobile</Label>
                                                    <InputGroup>
                                                        <InputGroupAddon addonType="prepend">
                                                            <Input

                                                                type="select"
                                                                name="mobileCode"
                                                                placeholder="code"
                                                                value={fields.mobileCode}
                                                                onChange={this.handleChange.bind(this)}>
                                                                {this.state.country.map((item, index) =>
                                                                    <option key={index} value={item.value}>{item.label}</option>
                                                                )}
                                                            </Input>
                                                        </InputGroupAddon>
                                                        <Input
                                                            invalid={("mobile" in errors)}
                                                            name="mobile"
                                                            type="text"
                                                            placeholder="Mobile"
                                                            value={fields.mobile}
                                                            onChange={this.handleChange.bind(this)}
                                                        />
                                                    </InputGroup>
                                                    <FormFeedback style={{ color: "red" }}>{errors.email}</FormFeedback>
                                                </FormGroup>
                                            </Col>
                                            <Col md={3} sm={6}>
                                                <FormGroup check className="ml-0 pl-0 mt-4">
                                                    <Label check>
                                                        <Checkbox
                                                            color="primary"
                                                        // onChange={()=>this.setState({ fields['isWhatsapp']:!this.state.isWhatsapp})}
                                                        // checked={this.state.fields.isWhatsapp}
                                                        />
                                                        <small>I have Whatsapp on mobile phone.</small>
                                                    </Label>
                                                </FormGroup>
                                            </Col>

                                        </Row> : ""}

                                    <Row>
                                        <Col >
                                            <FormGroup check className="ml-0 pl-0">
                                                <Label check>
                                                    <Checkbox
                                                        color="primary"
                                                        onChange={() => this.setState({ acceptTerms: !this.state.acceptTerms })}
                                                        checked={this.state.acceptTerms}
                                                    />
                                                    I read and accept site and ticket <Button color="link" onClick={() => this.setState({ showTerms: !this.state.showTerms })}>term and conditions.</Button>
                                                </Label>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                    {this.state.showTerms ?
                                        <Row>
                                            <Col >
                                                <p className="text-justify">
                                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                                                </p>
                                            </Col>
                                        </Row> : ""}
                                    <Row>
                                        <Col >
                                            <Button color="primary" size="lg" block className="mb-4 mt-4 btn-green" onClick={this.handleClick.bind(this)}>
                                                Continue Booking
                                            </Button>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }

    withoutSignValidate(e) {
        let result = true
        let fields = this.state.fields;
        let errors = {};

        if (validator.isEmpty(fields['email'])) {
            result = false;
            errors["email"] = LangValidation.required;
        } else if (!validator.isEmail(fields['email'])) {
            result = false;
            errors["email"] = LangValidation.email;
        }
        if (validator.isEmpty(fields['mobile'])) {
            result = false;
            errors["mobile"] = LangValidation.required;
        }
        this.setState({
            fields, errors
        });
        // console.log('3' + result)
        return result;
    }

    handleChange(event) {
        let fields = this.state.fields;
        let errors = {};
        let target = event.target;
        fields[target.name] = target.value;

        switch (target.name) {
            case 'email':
                if (validator.isEmpty(fields.email)) {
                    errors["email"] = LangValidation.required;
                } else if (!validator.isEmail(fields.email)) {
                    errors["email"] = LangValidation.email;
                }
                break;
            case 'mobile':
                if (validator.isEmpty(fields.mobile)) {
                    errors["mobile"] = LangValidation.required;
                }
                break;
            default:

        }
        this.setState({
            fields, errors
        });
        // console.log(this.state.fields)
    }

    async handleSetPassengerBus(passenger) {
        // console.log("get passenger from form by blur")
        // console.log(passenger)
        await this.setState({
            passengers: passenger
        });
    }

    async handleCheckPassengers(event) {
        event.preventDefault();

        if (this.state.showEmail === true) {
            let checkpassenger = await this.handlePassengerValidation((valid) => {
                if (valid === true) {
                    console.log(valid)
                    return true;
                } else {
                    console.log(valid)
                    return false;
                }
            });
            let checkemail = this.withoutSignValidate((valid) => {
                if (valid) {
                    console.log("email valid");
                    return true;
                } else {
                    return false;
                }
            });
            if (checkpassenger && checkemail) {
                this.setState({ formIsValid: true });
            } else {
                this.setState({ formIsValid: false });
            }

        } else if (this.state.plzlogin) {
            this.handlePassengerValidation((valid) => {
                if (valid) {
                    this.setState({ formIsValid: true });
                    console.log("all valid");

                    return true;
                } else {
                    return false;
                }
            });
        } else {
            alert('Sign in or Continue without Sign up')
        }

    }

    async handleClick(event) {
        event.preventDefault();
        //check contact form
        if (this.state.seats.length !== 0) {
            if (this.state.acceptTerms) {
                await this.handleCheckPassengers(event);
                // console.log(this.state.formIsValid)
                if (this.state.formIsValid === true) {
                    const userislogin = this.props.user.apiToken
                    this.setState({
                        loading: true
                    })
                    const passenger = this.state.passengers;
                    const seats = this.state.seats;
                    if (userislogin === null) {
                        console.log('not-login');
                        // console.log(passenger);
                        // console.log(seats);
                        // console.log(this.state.fields)
                        const user = this.state.fields;
                        this.props.setUserBus(user, passenger, seats);
                        this.props.goBackPassengers(false);
                        window.location.replace("./bus-ticket-review");

                    } else {
                        console.log('login');

                        const user = {
                            login: true,
                            api_token: userislogin
                        };
                        this.props.setUserBus(user, passenger, seats);
                        this.props.goBackPassengers(false);
                        window.location.replace("./bus-ticket-review");





                    }
                } else {
                    alert("Data your entered in not valid, please check again!")
                }

            } else {
                // let errors = {};
                // errors['terms'] = LangValidation.required;
                // this.setState({ errors });
                alert("Please accept our terms and conditions")
            }
        } else {
            alert("Please Choose at least one seat");
        }


    }



    handlePassengerValidation(callback) {
        const { passengers } = this.state;
        let newError = this.state.pError;
        let formIsValid = true;
        console.log("passengers check validate")
        console.log(passengers)

        // for (let i = 0; i < passengers.length; i++) {
        let cPassenger = passengers;
        console.log("cPassenger")
        console.log(cPassenger)

        let errors = newError;
        if (validator.isEmpty(cPassenger.name)) {
            formIsValid = false;
            errors["name"] = LangValidation.required;
        } else if (!validator.isLength(cPassenger.name, { min: 3, max: undefined })) {
            formIsValid = false;
            errors["name"] = LangValidation.min;
        }
        if (validator.isEmpty(cPassenger.family)) {
            formIsValid = false;
            errors["family"] = LangValidation.required;
        } else if (!validator.isLength(cPassenger.family, { min: 3, max: undefined })) {
            formIsValid = false;
            errors["family"] = LangValidation.min;
        }
        if (validator.isEmpty(cPassenger.BirthDate)) {
            formIsValid = false;
            errors["BirthDate"] = LangValidation.required;
        } else {
            // console.log(cPassenger.DocType)
            let passanger_age;
            // if (cPassenger.DocIssuedCountry !== "IR") {
            const todayyear = moment().format('YYYY');
            const selectedyear = cPassenger.BirthDate.substring(0, 4)
            passanger_age = todayyear - selectedyear
            // } else {
            //     const todayyear = momentJalaali().format('jYYYY');
            //     const selectedyear = cPassenger.BirthDate.substring(0, 4)
            //     passanger_age = todayyear - selectedyear
            // }
            // momentJalaali
            // console.log(momentJalaali().format('jYYYY'))
            // console.log(cPassenger.BirthDate)
            // console.log(passanger_age)
            switch (cPassenger.PassengerType) {
                case 1:
                    if (passanger_age < 12) {
                        formIsValid = false;
                        errors["BirthDate"] = LangValidation.adult_age;
                    }
                    break;
                case 2:
                    if (passanger_age < 2) {
                        // console.log(passanger_age)
                        formIsValid = false;
                        errors["BirthDate"] = LangValidation.child_age;
                    }
                    if (passanger_age > 12) {
                        // console.log(passanger_age)
                        formIsValid = false;
                        errors["BirthDate"] = LangValidation.child_age;
                    }
                    break;
                case 3:
                    console.log(cPassenger.DocIssuedCountry);
                    console.log(passanger_age);
                    if (passanger_age > 2) {
                        formIsValid = false;
                        errors["BirthDate"] = LangValidation.infant_age;
                    }
                    break;
                default: formIsValid = true
            }
        }
        if (parseInt(cPassenger.DocType, 10) === 1) {
            //passport
            console.log(cPassenger.passportExpire);
            if (cPassenger.passportId === null) {
                formIsValid = false;
                errors["passportId"] = LangValidation.required;
            } else {
                if (validator.isEmpty(cPassenger.passportId)) {
                    formIsValid = false;
                    errors["passportId"] = LangValidation.required;
                }
            }
            if (cPassenger.passportExpire === null) {
                formIsValid = false;
                errors["passportExpire"] = LangValidation.required;
            } else {
                if (validator.isEmpty(cPassenger.passportExpire)) {
                    formIsValid = false;
                    errors["passportExpire"] = LangValidation.required;
                }
            }
            // errors["nationalId"] = null;
        } else {
            //national id
            if (cPassenger.nationalId === null) {
                formIsValid = false;
                errors["nationalId"] = LangValidation.required;
            } else {
                if (validator.isEmpty(cPassenger.nationalId)) {
                    formIsValid = false;
                    errors["nationalId"] = null;
                } else if (cPassenger.nationalId.length !== 10) {
                    formIsValid = false;
                    errors["nationalId"] = LangValidation.national_id;
                }
            }
            // errors["passportId"] = null;
            // errors["passportExpire"] = null;
        }

        if (validator.isEmpty(cPassenger.DocIssuedCountry)) {
            formIsValid = false;
            errors["DocIssuedCountry"] = LangValidation.required;
        }
        // }
        this.setState({ pError: newError });
        return callback(formIsValid)
    }

    async handleRequest() {

    };
}
const mapStateToProps = (state) => {
    return {
        user: state.user,
        item: state.busticket.BusTicket
    }
};
const mapDispatchToProps = dispatch => {
    return {
        setUserBus: (user, passenger, seats) => {
            dispatch(setUserBus(user, passenger, seats))
        },
        goBackPassengers: (goback) => {
            dispatch(goBackPassengers(goback))
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(BusPassengers);


// WEBPACK FOOTER //
// ./src/containers/bus/BusPassengers.jsx